module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [_c('transition', {
    staticClass: "form-main__transition",
    attrs: {
      "name": "crossfade"
    }
  }, [(_vm.formSubmitted) ? _c('div', {
    staticClass: "form-main__spinner"
  }, [_c('span', [_vm._v("Sending")])]) : _vm._e()]), _c('transition', {
    staticClass: "form-main__transition",
    attrs: {
      "name": "crossfade"
    }
  }, [(!_vm.formSubmitted && _vm.$store.state.formSuccess) ? _c('div', {
    staticClass: "form-main__thankyou"
  }, [_c('h1', [_vm._v("Thank You")]), _c('div', {
    staticClass: "form-main__thankyou-text"
  }, [_vm._v("We'll get back to you shortly!")]), _c('div', {
    staticClass: "form-main__thankyou-button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close ")])]) : _vm._e()]), _c('transition', {
    staticClass: "form-main__transition",
    attrs: {
      "name": "crossfade"
    }
  }, [(!_vm.formSubmitted && !_vm.$store.state.formSuccess) ? _c('form', {
    staticClass: "form-main__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullname),
      expression: "fullname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('full-name')
    },
    attrs: {
      "name": "full-name",
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullname = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('full-name')),
      expression: "errors.has('full-name')"
    }]
  }, [_vm._v("Full name is required.")])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/
      }),
      expression: "{regex: /^\\D?(\\d{3})\\D?\\D?(\\d{3})\\D?(\\d{4})$/}"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }]
  }, [_vm._v("Please provide a valid phone number.")])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }]
  }, [_vm._v("Please provide a valid email.")])])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-main__textarea",
    class: {
      'form-main__textarea--error': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "textarea",
      "rows": "2",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "form-main__error-container"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('message')),
      expression: "errors.has('message')"
    }]
  }, [_vm._v("Send us a message so we can help you better!")])])]), _c('div', {
    staticClass: "form-main__button-group"
  }, [_c('button', {
    staticClass: "form-main__submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.formSubmitted
    }
  }, [_c('span', [_vm._v("Submit")])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587ad0d0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form.pug
// module id = 695
// module chunks = 1